import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../../features/auth";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { initialMapFiltersState } from "../../../widgets/map/mapAddons/mapOverlayWidget/roadWorksWithNormativitiesOverlay/map.filters.config";

export type MapRoadWorksWithNormativitiesFilters = {
    workState: any,
    StartDate: any,
    EventStandartTypeId: any,
    DiagnosticYear: any
}

type MapRoadWorksWithNormativitiesSlice = {
    filterMenuIsExpanded: boolean,
    filterMenuActiveTabs: number[],
    mapFiltersState: MapRoadWorksWithNormativitiesFilters,
    appliedFilters: MapRoadWorksWithNormativitiesFilters,
    mapFiltersExpressions: object | null,
    tableFiltersString: string | null
}

function getInitialState() {
    const mapsPreferences = getItemWebStorage("mapsPreferences")?.["RoadWorksWithNormativities"]
    const { mapFiltersState: localMapFiltersState, appliedFilters: localAppliedFilters, filterMenuActiveTabs: localFilterMenuActiveTabs } = mapsPreferences ?? {}
    const mapFiltersState: MapRoadWorksWithNormativitiesFilters = localAppliedFilters
        ? localMapFiltersState as MapRoadWorksWithNormativitiesFilters
        : initialMapFiltersState
    const initialState: MapRoadWorksWithNormativitiesSlice = {
        filterMenuIsExpanded: false,
        filterMenuActiveTabs: localFilterMenuActiveTabs,
        mapFiltersState,
        appliedFilters: localAppliedFilters,
        mapFiltersExpressions: null,
        tableFiltersString: null
    };
    return initialState
}

export const mapRoadWorksWithNormativitiesSlice = createSlice({
    name: 'mapRoadWorksWithNormativities',
    initialState: getInitialState(),
    reducers: {
        setFilterMenuIsExpanded(state, action: PayloadAction<any>) {
            state.filterMenuIsExpanded = action.payload
        },
        setFilterMenuActiveTabs(state, action: PayloadAction<any>) {
            state.filterMenuActiveTabs = action.payload
        },
        setMapFiltersState(state, action: PayloadAction<any>) {
            state.mapFiltersState = action.payload
        },
        patchMapFiltersState(state, action: PayloadAction<{ fieldName: keyof MapRoadWorksWithNormativitiesFilters, patch: any }>,
        ) {
            const { fieldName, patch } = action.payload;
            state.mapFiltersState[fieldName] = { ...state.mapFiltersState[fieldName], ...patch };
        },
        resetAllMapFilters(state) {
            state.mapFiltersState = structuredClone(initialMapFiltersState)
        },
        resetSingleMapFilter(state, action: PayloadAction<keyof MapRoadWorksWithNormativitiesFilters>) {
            const fieldName = action.payload
            if (fieldName in initialMapFiltersState) {
                state.mapFiltersState[fieldName] = structuredClone(initialMapFiltersState[fieldName])
            }
        },
        setAppliedFilters(state, action: PayloadAction<any>) {
            state.appliedFilters = action.payload
        },
        setMapFiltersExpressions(state, action: PayloadAction<any>) {
            state.mapFiltersExpressions = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const {
    setFilterMenuIsExpanded,
    setFilterMenuActiveTabs,
    setMapFiltersState,
    setAppliedFilters,
    patchMapFiltersState,
    resetAllMapFilters,
    resetSingleMapFilter,
    setMapFiltersExpressions
} = mapRoadWorksWithNormativitiesSlice.actions;
export const mapRoadWorksWithNormativitiesReducer = mapRoadWorksWithNormativitiesSlice.reducer;
